// <auto-generated>
// This file is automatically generated from DSL.
// Do not modify this file directly. Changes will be overwritten.
// Source: dsl/entities/PlanDriverLine.yaml
// Generated: 2026-06-16T13:50:05.762Z
// </auto-generated>

import type { AuditedEntityBase } from '../base';

/**
 * Carries only the extra INPUT drivers that don"t fit PlanLine"s two slots (e.g. UTILIZATION). No account, no formula. Exists solely for boundary rule (2). requirementId: PlanBudgetInmatningsmodell-PlanDriverLine.
 */
export interface PlanDriverLine extends AuditedEntityBase {
  /** The plan line the driver belongs to. */
  planLineId: string;
  /** The Measure.Code this value came from, e.g. UTILIZATION. */
  measureCode: string;
  /** The driver value. Scale 4 preserves RATE/RATIO precision (e.g. utilization 0.8333). */
  value: number;
  /** QUANTITY / RATE / RATIO (never AMOUNT — a driver is non-financial input). (dynamic enum: MeasureValueType) */
  valueType: string;
  /** Optional unit. */
  unit?: string;
}

/**
 * Create PlanDriverLine DTO
 * Note: Scope is NOT included - it's derived by backend from user session context
 */
export interface CreatePlanDriverLine {
  /** The plan line the driver belongs to. */
  planLineId: string;
  /** The Measure.Code this value came from, e.g. UTILIZATION. */
  measureCode: string;
  /** The driver value. Scale 4 preserves RATE/RATIO precision (e.g. utilization 0.8333). */
  value: number;
  /** QUANTITY / RATE / RATIO (never AMOUNT — a driver is non-financial input). (dynamic enum: MeasureValueType) */
  valueType: string;
  /** Optional unit. */
  unit?: string;
}

/**
 * Update PlanDriverLine DTO
 */
export interface UpdatePlanDriverLine {
  /** The plan line the driver belongs to. */
  planLineId: string;
  /** The Measure.Code this value came from, e.g. UTILIZATION. */
  measureCode: string;
  /** The driver value. Scale 4 preserves RATE/RATIO precision (e.g. utilization 0.8333). */
  value: number;
  /** QUANTITY / RATE / RATIO (never AMOUNT — a driver is non-financial input). (dynamic enum: MeasureValueType) */
  valueType: string;
  /** Optional unit. */
  unit?: string;
}


/**
 * The decimal places each Decimal field of PlanDriverLine stores: its column's scale. A value with more is rounded
 * half away from zero when it is stored.
 */
export const PlanDriverLineScales = {
  value: 4,
} as const;

